/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { IContentLoaderProps } from "react-content-loader";
import styled from "styled-components";
import { Loader, LoaderProps } from "@nordcloud/gnui";

export type LoaderWrapProps = IContentLoaderProps &
  LoaderProps & {
    loading: boolean;
    children: React.ReactNode;
    Component?: React.FC;
  };

const Wrap = styled.div`
  margin-bottom: 1rem;
`;
export function LoaderWrap({
  loading,
  children,
  Component = Loader as React.FC<LoaderProps>,
  ...props
}: LoaderWrapProps) {
  return loading ? (
    <Wrap>
      <Component inContent {...props} />
    </Wrap>
  ) : (
    <>{children}</>
  );
}
